import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Style from "./datepicker.module.scss";
import PropTypes from "prop-types";
import { yyyyMMMd } from "../../utils/constants/appConstants";

const SalesLeadDatePicker = ({ value, onChange }) => {
  return (
    <ReactDatePicker
      className={Style.datepicercustom}
      selected={value}
      onChange={(date) => onChange(date)}
      dateFormat={yyyyMMMd}
      popperClassName={Style.datePickerPopper}
      portalId="root"
    />
  );
};

SalesLeadDatePicker.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired
};

export default SalesLeadDatePicker;
